
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1360","height":"372","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1359.03.21H0v371.26h1359.03V.21z","fill":"#4D4D4D"}}),_c('path',{attrs:{"d":"M35.02 22.98H22.04c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zm0 313H22.04c-6.633 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.377 12.01 12.01 12.01h12.98c6.633 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.377-12.01-12.01-12.01zM1338.34 22.81h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01zm0 313h-12.98c-6.63 0-12.01 5.377-12.01 12.01v.98c0 6.633 5.38 12.01 12.01 12.01h12.98c6.63 0 12.01-5.377 12.01-12.01v-.98c0-6.633-5.38-12.01-12.01-12.01z","fill":"#fff","stroke":"#4D4D4D","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M77 .21v.45c0 8.13 2.29 14.73 5.1 14.73 2.81 0 5.14-6.6 5.14-14.73V.21H77zm-6 371.26V371c0-8.14 2.29-14.73 5.1-14.73 2.81 0 5.11 6.59 5.11 14.73v.44l-10.21.03zM1266.8 0v.45c0 8.13 2.28 14.72 5.1 14.72s5.1-6.59 5.1-14.72V0h-10.2zm-6 371.26v-.45c0-8.13 2.28-14.73 5.1-14.73s5.1 6.6 5.1 14.73v.45h-10.2z","fill":"#fff"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h1359.03v371.47H0z"}})])])])
          )
        }
      }
    